import { render, staticRenderFns } from "./SuccessReceipt.vue?vue&type=template&id=d570c8d8&scoped=true&"
import script from "./SuccessReceipt.vue?vue&type=script&lang=js&"
export * from "./SuccessReceipt.vue?vue&type=script&lang=js&"
import style0 from "./SuccessReceipt.vue?vue&type=style&index=0&id=d570c8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d570c8d8",
  null
  
)

export default component.exports